import {Component, OnDestroy, OnInit, ViewEncapsulation,} from '@angular/core';
import {ApiService} from '../../services/api/api.service';
import {ActivatedRoute} from '@angular/router';
import {UserContext} from '../../services/user-context/user-context';
import {ShippingComponent} from './components/shipping/shipping.component';
import {Subject} from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import {UploadAssetComponent} from './components/upload/upload.component';

@Component({
  selector: 'app-order-detail',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'order-detail.template.html',
  styleUrls: [
    './order-detail.style.scss'
  ]
})
export class OrderDetailComponent implements OnInit, OnDestroy {
  public crumbs: any[] = [
    {label: 'Orders', link: '/orders'}
  ];
  public accomodations: any[];
  public postings: any[];
  public diagnoses: any[];
  public complaints: any[];
  public supplier: any;

  downloadOptions: Array<any> = [];

  public statuses: Array<string> = [
    'CANCELLED', 'STAGING', 'PENDING', 'PRODUCTION', 'SHIPPED', 'DELIVERED', 'ANALYZED'
  ];
  private orderId: string;
  private order: any;
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(private route: ActivatedRoute,
              private userContext: UserContext,
              public dialog: MatDialog,
              private api: ApiService) {

  }


  public ngOnInit(): void {
    this.orderId = this.route.snapshot.paramMap.get('id');

    this.refresh();
  }

  public refresh(): void {
    this.api.get<any>(`/order/${this.orderId}`)
      .subscribe(result => {
        this.order = result;

        this.diagnoses = [];

        if ( this.order.diagnostic && this.order.diagnostic.diagnoses ) {
          if ( this.order.diagnostic.diagnoses.left ) {
            this.order.diagnostic.diagnoses.left.forEach((item, index) => {
              this.diagnoses.push({foot: 'Left', condition: item });
            });
          }
          if ( this.order.diagnostic.diagnoses.right ) {
            this.order.diagnostic.diagnoses.right.forEach((item, index) => {
              this.diagnoses.push({foot: 'Right', condition: item });
            });
          }
        }

        this.accomodations = [];
        if ( this.order.diagnostic && this.order.diagnostic.accommodations ) {
          for ( const key in this.order.diagnostic.accommodations ) {
            if ( this.order.diagnostic.accommodations.hasOwnProperty(key) ) {
              if (this.order.diagnostic.accommodations[key].left) {
                this.accomodations.push({
                  type: key,
                  foot: 'Left',
                  configuration: this.configurationToString(this.order.diagnostic.accommodations[key].left)});
              }
              if (this.order.diagnostic.accommodations[key].right) {
                this.accomodations.push({
                  type: key,
                  foot: 'Right',
                  configuration: this.configurationToString(this.order.diagnostic.accommodations[key].right)});
              }
            }
          }
        }

        this.postings = [];
        if ( this.order.diagnostic && this.order.diagnostic.postings ) {
          for ( const postingKey in this.order.diagnostic.postings ) {
            if ( this.order.diagnostic.postings.hasOwnProperty(postingKey) ) {
              const posting = this.order.diagnostic.postings[postingKey];
              if (posting.left) {
                this.postings.push(
                  {posting: postingKey, foot: 'Left', type: posting.type, units: posting.units, value: posting.left.value});
              }
              if (posting.right) {
                this.postings.push(
                  {posting: postingKey, foot: 'Right', type: posting.type, units: posting.units, value: posting.right.value});
              }
            }
          }
        }

        this.api.get<any>(`/order/${this.orderId}/supplier`)
          .subscribe(supplier => {

            this.supplier = supplier;
            console.log('got supplier ' + JSON.stringify(supplier));
          });

        this.api.get<any>(`/order/${this.orderId}/resources`)
          .subscribe(resources => {

            this.downloadOptions = resources;
            console.log('got resources ' + JSON.stringify(resources));
          });

      }, (error) => {
        console.log('Found error ' + JSON.stringify(error));
      });
  }

  public statusChange(event: any) {

    this.order.status = event;

    if (this.order.status === 'SHIPPED') {

      // Ask for shipping information
      const dialogRef = this.dialog.open(ShippingComponent, {
        width: '250px',
        data: this.order.tracking || {}
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.api.patch<any>(`/order/${this.orderId}`, {status: this.order.status, tracking: result})
            .subscribe( patchResult => {
              this.order = patchResult;
            }, (error) => {
              console.log('Found error patching ' + JSON.stringify(error));
            });
        } else {
          this.refresh();
        }
      });
    } else {
      this.api.patch<any>(`/order/${this.orderId}`, {status: this.order.status})
        .subscribe( patchResult => {
          this.order = patchResult;
        }, (error) => {
          console.log('Found error patching ' + JSON.stringify(error));
        });
    }
  }

  public upload(event: any) {
    const dialogRef = this.dialog.open(UploadAssetComponent, {
      width: '500px',
      data: {id: this.orderId}
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  public isAuthorizedToUpload() {
    return this.userContext.hasRole('administrator') || this.userContext.user.supplier_id;
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private configurationToString(a) {
    let configuration = '';
    for ( const key in a ) {
      if (a.hasOwnProperty(key)) {
        configuration += key + ' = ' + a[key] + '; ';
      }
    }
    return configuration;
  }
}
